import { Box, IconButton, Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Copy } from 'lucide-react';
import { useState } from 'react';
import { useIntl } from 'react-intl';

type CopyFieldProps = {
    label: string | number;
    size?: number;
};

export default function CopyField({ label, size = 14 }: CopyFieldProps) {
    const intl = useIntl();
    const [isCopied, setIsCopied] = useState(false);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(label.toString());
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 3000);
    };

    const tooltipText = intl.formatMessage({
        id: isCopied ? 'copied' : 'copyToClipboard',
    });

    return (
        <Box
            display="flex"
            alignItems="center"
            gap={0.25}
            onMouseLeave={() => setIsCopied(false)}
            sx={{
                position: 'relative',
                '&:hover .copy-icon': {
                    opacity: 1,
                },
            }}
        >
            <Typography fontSize={size}>{label}</Typography>
            <Tooltip title={tooltipText} arrow>
                <IconButton
                    size="small"
                    color="primary"
                    onClick={copyToClipboard}
                    className="copy-icon"
                    aria-label={tooltipText}
                    sx={{
                        my: -2,
                        opacity: 0,
                        transition: 'opacity 0.2s',
                        position: 'relative',
                        left: 1,
                    }}
                >
                    <Copy size={10} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
